/* STEFANO - bottone "Provali online" dell'app Auglio: traduzione in inglese del testo. Prima stava nel codice inserito con XO Insert Code. */
(function () {
  if (document.documentElement.lang !== 'en') return;

  function translateBtn(node) {
    if (
      node.nodeType === 1 &&
      node.classList.contains('auglio-tryon-btn') &&
      node.innerHTML.includes('PROVALI ONLINE')
    ) {
      node.innerHTML = node.innerHTML.replace('PROVALI ONLINE', 'VIRTUAL TRY ON');
      observer.disconnect();
    }
  }

  document.querySelectorAll('.auglio-tryon-btn').forEach(translateBtn);

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        translateBtn(node);
        if (node.querySelectorAll) {
          node.querySelectorAll('.auglio-tryon-btn').forEach(translateBtn);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
